<template>
  <div class="job-detail app-main-content">
    <!-- 返回按钮 -->
    <el-card class="toolbar-card" shadow="never">
      <el-button icon="el-icon-back" @click="goBack">返回</el-button>
    </el-card>

    <!-- 数据表格 -->
    <el-card shadow="never">
      <!-- TODO: 后期可能需要启用UI自定义配置，取消注释并移除 disable-ui-custom -->
      <!-- <cargo-ag-grid -->
      <!--   ref="agGrid" -->
      <!--   :grid-options="gridOptions" -->
      <!--   :column-defs="finalColumnDefs" -->
      <!--   :row-data="rowData" -->
      <!--   style="width: 100%; height: 100%;" -->
      <!--   config-module="PROVISION_JOB_DETAIL" -->
      <!-- /> -->

      <cargo-ag-grid
        ref="agGrid"
        :config-module="provisionConfigModule"
        :grid-options="gridOptions"
        :column-defs="finalColumnDefs"
        :row-data="rowData"
        :filter-menu-items="filterMenuItems"
        style="width: 100%; height: 100%;"
        @gridReady="onGridReady"
      />

      <!-- 分页 -->
      <cargo-pagination
        class="pagination"
        :total="total"
        :page.sync="queryParams.page"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </el-card>
  </div>
</template>

<script>
import { getJobDetailList } from '@/api/provision/provisionData'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import * as ProvisionConstants from '@/class/cargo/model/parameters/ProvisionConstants'

export default {
  name: 'JobDetail',
  data() {
    return {
      // ========== 查询参数 ==========
      queryParams: {
        detailUuid: '',
        page: 1,
        pageSize: 100
      },

      // ========== 表格数据 ==========
      rowData: [],
      total: 0,

      // ========== AG Grid实例 ==========
      gridApi: null,

      // ========== AG Grid配置 ==========
      gridOptions: {
        // 启用多选模式
        rowSelection: 'multiple',
        // 禁止点击行选中
        suppressRowClickSelection: true
      },

      // 计提查询配置模块（使用字符串，与cargoAgGrid组件的configModule属性类型对应）
      provisionConfigModule: String(ProvisionConstants.PROVISION_DATA_QUERY),

      // ========== 表格列定义（对应后端返回字段）==========
      defaultColumnDefs: [
        // 复选框列配置（固定在左侧第一列）
        {
          headerCheckboxSelection: true, // 表头显示全选复选框
          checkboxSelection: true, // 每行显示复选框
          showDisabledCheckboxes: true, // 显示禁用状态的复选框
          width: 50, // 列宽
          pinned: 'left', // 固定在左侧
          suppressSizeToFit: true, // 禁止自动调整大小
          sortable: false, // 禁止排序
          resizable: false, // 禁止拖拽调整宽度
          suppressMovable: true // 禁止移动列位置
        },

        { field: 'jobNo', headerName: '业务编号', width: 150, sortable: true },
        { field: 'customerName', headerName: '客户', width: 200, sortable: true },
        {
          field: 'businessDate',
          headerName: '业务日期',
          width: 120,
          sortable: true,
          valueFormatter: params => this.formatDate(params.value)
        },
        { field: 'businessType', headerName: '业务类型', width: 120, sortable: true },
        { field: 'customJobTypeName', headerName: '自定义业务类型', width: 150, sortable: true },
        { field: 'incoTerm', headerName: '贸易条款', width: 120, sortable: true },
        { field: 'carrierName', headerName: '运输公司', width: 150, sortable: true },
        { field: 'cubageActual', headerName: '实际体积', width: 120, sortable: true },
        {
          field: 'grossProfit',
          headerName: '毛利',
          headerTooltip: '计提生成时每票毛利快照，可能与计息毛利总额口径不一致',
          width: 120,
          type: 'numericColumn',
          sortable: true,
          valueFormatter: ({ value }) => (value == null ? '-' : Number(value).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
        },
        {
          field: 'consolidationNo',
          headerName: '加拼单号',
          width: 150,
          sortable: true,
          valueFormatter: params => {
            if (!params.value) return ''
            // 将换行符替换为逗号
            return params.value.replace(/\n/g, ',')
          }
        },
        { field: 'operator', headerName: '操作', width: 120, sortable: true },
        { field: 'operatorDept', headerName: '操作部门', width: 150, sortable: true },
        { field: 'salesName', headerName: '销售', width: 120, sortable: true },
        { field: 'salesDept', headerName: '销售部门', width: 150, sortable: true },
        { field: 'customerServiceName', headerName: '客服', width: 120, sortable: true },
        { field: 'customerServiceDept', headerName: '客服部门', width: 150, sortable: true },
        { field: 'overseasFollow', headerName: '海外跟单', width: 120, sortable: true },
        {
          field: 'arFullVerifiedTime',
          headerName: '应收全部核销时间',
          width: 160,
          sortable: true,
          valueFormatter: params => this.formatDateTime(params.value)
        }
      ]
    }
  },
  computed: {
    /**
     * 最终列定义（直接使用默认列定义）
     */
    finalColumnDefs() {
      // TODO: 后期如需启用UI自定义配置，可取消注释以下代码
      // if (this.$store.state.uiCustom && this.$store.state.uiCustom.enable) {
      //   return UICustomUtil.handleColumnDefs(
      //     ProvisionConstants.PROVISION_DATA_MODULE,
      //     this.$store.getters.currentOfficeId,
      //     this.defaultColumnDefs
      //   )
      // }
      // 当前直接使用默认列定义
      return this.defaultColumnDefs
    }
  },
  created() {
    // 加载参数并查询（只执行一次）
    this.loadParamsAndQuery()

    // 加载UI配置
    if (this.$store.state.uiCustom && this.$store.dispatch) {
      this.$store.dispatch('uiCustom/loadUICustomPageInfo', {
        pageType: ProvisionConstants.PROVISION_JOB_DETAIL,
        branchId: this.$store.getters.currentOfficeId
      }).catch(() => {
        // UI配置加载失败不影响页面显示
      })
    }
  },
  methods: {
    // ========== AG Grid事件处理 ==========

    /**
     * AG Grid 初始化完成
     */
    onGridReady(params) {
      this.gridApi = params.api
      console.log('AG Grid 已初始化')

      // 如果已经有数据，立即设置
      if (this.rowData.length > 0) {
        this.gridApi.setRowData(this.rowData)
      }
    },

    // ========== 数据查询方法 ==========

    /**
     * 加载参数并查询数据
     */
    loadParamsAndQuery() {
      // 从路由参数获取detailUuid
      this.queryParams.detailUuid = this.$route.query.detailUuid

      if (this.queryParams.detailUuid) {
        this.getList()
      }
    },

    /**
     * 获取业务详情列表（分页）
     */
    async getList() {
      try {
        const params = {
          detailUuid: this.queryParams.detailUuid,
          pageNum: this.queryParams.page,
          pageSize: this.queryParams.pageSize
        }

        console.log('查询参数:', params)
        const res = await getJobDetailList(params)
        console.log('接口返回:', res)

        if (res.ok && res.data) {
          this.rowData = res.data.list || []
          this.total = res.data.total || 0
          console.log('rowData:', this.rowData)
          console.log('total:', this.total)

          // 使用 AG Grid API 设置数据
          if (this.gridApi) {
            this.gridApi.setRowData(this.rowData)
            console.log('AG Grid 数据已刷新')
          }
        }
      } catch (error) {
        console.error('加载业务详情失败:', error)
        this.$message.error('加载业务详情失败')
      }
    },

    // ========== 工具方法 ==========

    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1)
    },

    /**
     * 格式化日期为年月日格式（yyyy-MM-dd）
     * @param {Date|String} date - 日期对象或字符串
     * @returns {String} 格式化后的日期字符串
     */
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    /**
     * 过滤右键菜单项，只保留Excel导出选项
     * @param {Array} menus - 原始菜单项数组
     * @returns {Array} 过滤后的菜单项数组
     */
    filterMenuItems(menus) {
      // 只保留包含"导出Excel"的菜单项
      return menus.filter(menu => {
        if (typeof menu === 'object' && menu.name) {
          return menu.name.indexOf('导出Excel') !== -1
        }
        return false
      })
    },

    /**
     * 格式化日期时间为完整格式（yyyy-MM-dd HH:mm）
     * @param {Date|String} date - 日期对象或字符串
     * @returns {String} 格式化后的日期时间字符串
     */
    formatDateTime(date) {
      if (!date) return ''
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hour = String(d.getHours()).padStart(2, '0')
      const minute = String(d.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hour}:${minute}`
    }
  }
}
</script>

<style scoped lang="scss">
.job-detail {
  padding: 10px;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 100px);
  overflow: hidden;

  .toolbar-card {
    margin-bottom: 10px;
    flex-shrink: 0;
    display: flex;
    align-items: center;

    .title {
      margin-left: 16px;
      font-size: 16px;
      font-weight: bold;
    }
  }

  ::v-deep .el-card__body {
    padding-bottom: 10px;
  }

  .pagination {
    margin-top: 10px;
    text-align: right;
    flex-shrink: 0;
  }

  ::v-deep .el-card {
    flex-shrink: 0;
  }

  // 让数据表格卡片占据剩余空间
  > .el-card:nth-child(2) {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 0;

    ::v-deep .el-card__body {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      padding-bottom: 10px;
      min-height: 400px;
    }
  }
}
</style>
